import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Flex, Image, Text, ButtonFilled, ButtonText } from 'Components/Base';

const ClearCompleteContent = ({ onBackToClassroom, onGoToClearSite }) => {
  const { t } = useTranslation('classroom');
  return (
    <Flex width={1} flexDirection={'column'} alignItems={'center'} height="100%">
      <Image maxWidth={140} src="/assets/images/classroom/clearCompleteModal.svg" />
      <Flex width={1} flexDirection={'column'} alignItems={'center'}>
        <Text textStyle={'heading2'} mt={6} textAlign={'center'}>
          {t('CLEAR_BY_LEARNED.COMPLETE_MODAL.TITLE')}
        </Text>
        <Text mt={4} textAlign={'center'}>
          {t('CLEAR_BY_LEARNED.COMPLETE_MODAL.DESCRIPTION')}
        </Text>
      </Flex>
      <ButtonFilled
        onClick={onBackToClassroom}
        mt={'auto'}
        width={1}
        maxWidth={'300px'}
        borderRadius="8px"
      >
        {t('CLEAR_BY_LEARNED.COMPLETE_MODAL.BACK_TO_CLASSROOM')}
      </ButtonFilled>
      <ButtonText onClick={onGoToClearSite} mt={4} width={1} maxWidth={'300px'} py={0} px={0}>
        {t('CLEAR_BY_LEARNED.COMPLETE_MODAL.GO_TO_CLEAR_SITE')}
      </ButtonText>
    </Flex>
  );
};

ClearCompleteContent.propTypes = {
  onBackToClassroom: PropTypes.func,
  onGoToClearSite: PropTypes.func,
};

export default ClearCompleteContent;
